<template>
  <div class="mahai-auth">
    <div class="mahai-auth-card">
      <div class="mahai-auth-logo">
        <img :src="require('@/assets/images/ymlogo.png')" alt="Mahai" class="logo-img" />
      </div>

      <div class="status-icon">
        <i class="material-symbols-outlined" v-if="!loading">check_circle</i>
        <i class="material-symbols-outlined spinning" v-else>progress_activity</i>
      </div>

      <h2 class="mahai-auth-title">{{ loading ? 'Çıkış yapılıyor…' : 'Görüşmek üzere!' }}</h2>
      <p class="mahai-auth-subtitle" v-if="!loading">Oturumunuz güvenle kapatıldı.</p>

      <div class="user-info" v-if="displayName || email">
        <div class="user-avatar">
          {{ getInitials(displayName || email) }}
        </div>
        <span class="user-name">{{ displayName || email }}</span>
      </div>

      <p class="info-msg" v-if="message">{{ message }}</p>
      <p class="error-msg" v-if="error">{{ error }}</p>

      <RouterLink class="mahai-btn-primary" to="/authentication/sign-in">
        <i class="material-symbols-outlined">login</i>
        Tekrar Giriş Yap
      </RouterLink>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Logout',
  data() {
    return {
      loading: true,
      email: '',
      displayName: '',
      message: '',
      error: '',
      autoRedirect: false,
      redirectAfterMs: 1200
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return '?'

      if (name.includes('@')) {
        name = name.split('@')[0]
      }

      const parts = name.trim().split(/\s+/)

      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase()
      } else if (parts.length === 1 && parts[0].length >= 2) {
        return parts[0].substring(0, 2).toUpperCase()
      }

      return parts[0][0].toUpperCase()
    },
    async doLogout() {
      this.loading = true
      this.error = ''
      this.message = ''

      try {
        const storedUser = localStorage.getItem('auth_user')
        if (storedUser) {
          try {
            const user = JSON.parse(storedUser)
            this.email = user?.email || ''
            this.displayName = user?.name || user?.full_name || ''
          } catch (e) {
            // parse hatası olursa boş geç
          }
        }

        const token = localStorage.getItem('auth_token')

        if (token) {
          try {
            await axios.post(
              `${API_BASE_URL}/logout`,
              null,
              {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }
            )
          } catch (apiErr) {
            console.error('API logout hatası:', apiErr)
          }
        }

        localStorage.removeItem('auth_token')
        localStorage.removeItem('auth_user')
        delete axios.defaults.headers.common['Authorization']

        this.message = 'Güvenli çıkış yapıldı.'

        if (this.autoRedirect) {
          setTimeout(() => {
            this.$router.replace('/authentication/sign-in')
          }, this.redirectAfterMs)
        }
      } catch (e) {
        this.error = e?.message || 'Çıkış yapılamadı, lütfen tekrar deneyin.'
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    try {
      await this.doLogout()
    } catch (e) {
      // bilinçli sessiz
    }
  }
}
</script>

<style lang="scss" scoped>
.mahai-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  padding: 20px;
}

.mahai-auth-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 16px;
  padding: 48px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.mahai-auth-logo {
  margin-bottom: 24px;

  .logo-img {
    height: 128px;
    width: auto;
    object-fit: contain;
  }
}

.status-icon {
  margin-bottom: 16px;

  i {
    font-size: 56px;
    color: #22c55e;
  }

  .spinning {
    color: #3b82f6;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.mahai-auth-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.mahai-auth-subtitle {
  font-size: 15px;
  color: #64748b;
  margin: 0 0 24px;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .user-name {
    font-size: 15px;
    font-weight: 600;
    color: #334155;
  }
}

.info-msg {
  font-size: 14px;
  color: #166534;
  margin-bottom: 20px;
}

.error-msg {
  font-size: 14px;
  color: #991b1b;
  margin-bottom: 20px;
}

.mahai-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(37, 99, 235, 0.4);
    color: #fff;
  }

  i {
    font-size: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .mahai-auth-card {
    padding: 32px 24px;
  }

  .mahai-auth-logo .logo-img {
    height: 96px;
  }

  .mahai-auth-title {
    font-size: 20px;
  }

  .status-icon i {
    font-size: 44px;
  }
}
</style>
